import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=37625a47"
import script from "./AppBody.vue?vue&type=script&lang=ts"
export * from "./AppBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports